import React from 'react'
import { RED_70, WHITE } from '@omnilert/components'

/**
 * Renders an emergency vehicle SVG icon depicting police and fire vehicles
 * @returns {JSX.Element} Emergency icon SVG element
 */
function Icon() {
  return (
    <svg
      fill='none'
      height='64'
      viewBox='0 0 166 64'
      width='166'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M107 30.667h2.667A2.666 2.666 0 00112.333 28v-5.333A2.667 2.667 0 00109.667 20H107M107 57.333l-8-10.666'
        stroke={RED_70}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M69.667 57.333V60A2.667 2.667 0 0167 62.667h-2.667A2.666 2.666 0 0161.667 60v-2.667M104.333 57.333V60a2.667 2.667 0 01-2.666 2.667H99A2.667 2.667 0 0196.333 60v-2.667M107 46.667H59a2.667 2.667 0 00-2.667 2.666v5.334A2.667 2.667 0 0059 57.333h48a2.667 2.667 0 002.667-2.666v-5.334A2.667 2.667 0 00107 46.667zM59 46.667V17.333a2.667 2.667 0 012.667-2.666h42.666A2.666 2.666 0 01107 17.333v29.334'
        stroke={RED_70}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M69.667 14.667V12A2.667 2.667 0 0067 9.333h-2.667A2.666 2.666 0 0061.667 12v2.667M104.333 14.667V12a2.667 2.667 0 00-2.666-2.667H99A2.667 2.667 0 0096.333 12v2.667M59 30.667h48M68.333 42.667a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334zM97.667 42.667a2.666 2.666 0 100-5.333 2.666 2.666 0 000 5.333zM83 14.667v16M59 57.333l8-10.666M67 57.333l8-10.666M99 57.333l-8-10.666M91 57.333l-8-10.666-8 10.666M76.333 36h13.334M76.333 41.333h13.334M59 30.667h-2.667A2.667 2.667 0 0153.667 28v-5.333A2.667 2.667 0 0156.333 20H59M75 1.333v13.334h16V1.333M71 4h25.333'
        stroke={RED_70}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <g
        clipPath='url(#clip0)'
        stroke={RED_70}
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path
          d='M14 56v3a1 1 0 01-1 1H9a1 1 0 01-1-1v-3M40 56v3a1 1 0 01-1 1h-4a1 1 0 01-1-1v-3M4 53a3 3 0 003 3h34a3 3 0 000-6H7a3 3 0 00-3 3v0z'
          strokeWidth='2'
        />
        <path d='M42 50.174V39.086l-3.784-12.378A1 1 0 0037.26 26H10.742a1 1 0 00-.958.71L6 39.166v11M6 40h36' />
        <path d='M6 44h5a1 1 0 011 1v5M36 50v-5a1 1 0 011-1h5' />
        <path
          d='M46 48V16a2 2 0 00-2-2H4a2 2 0 00-2 2v32'
          strokeWidth='2'
        />
        <path d='M11 18H7a1 1 0 00-1 1v2a1 1 0 001 1h4a1 1 0 001-1v-2a1 1 0 00-1-1zM41 18h-4a1 1 0 00-1 1v2a1 1 0 001 1h4a1 1 0 001-1v-2a1 1 0 00-1-1zM31 18H17a1 1 0 00-1 1v2a1 1 0 001 1h14a1 1 0 001-1v-2a1 1 0 00-1-1z' />
      </g>
      <g
        clipPath='url(#clip1)'
        stroke={RED_70}
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path
          d='M126.25 51.5v3a.998.998 0 01-1 1h-4a.999.999 0 01-1-1v-3.536M162.25 50.964V54.5a.998.998 0 01-1 1h-4a.999.999 0 01-1-1v-3'
          strokeWidth='2'
        />
        <path
          d='M160.25 51.5a3.999 3.999 0 004-4v-4l-6-8h-34l-6 8v4a3.997 3.997 0 004 4h38zM158.25 35.5l-3.772-11.316a1 1 0 00-.95-.684H128.97a.998.998 0 00-.948.684L124.25 35.5'
          strokeWidth='2'
        />
        <path d='M124.25 35.5h-5a1 1 0 01-1-1v-2a.998.998 0 011-1h6.334M156.916 31.5h6.334a.999.999 0 011 1v2a.998.998 0 01-1 1h-5M118.25 43.5h4a8 8 0 018 8M152.25 51.5a8.001 8.001 0 018-8h4M122.25 43.5h38M133.25 47.5h16M150.25 23.5a6 6 0 00-6-6h-6a6.003 6.003 0 00-6 6M138.25 17.5v6M144.25 17.5v6M140.25 13.5v-3M146.25 13.5l2-2M135.25 13.5l-2-2' />
      </g>
      <defs>
        <clipPath id='clip0'>
          <path
            d='M0 13H48V61H0z'
            fill={WHITE}
          />
        </clipPath>
        <clipPath id='clip1'>
          <path
            d='M117.25 9H165.25V57H117.25z'
            fill={WHITE}
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Icon

